<script>
import SimpleNotification from './SimpleNotification.vue';

export default {
  name: 'NotificationCenter',
  components: { SimpleNotification },
  data() {
    return {
      sequence: 1,
      messages: [],
    };
  },
  mounted() {
    window.addEventListener('search:pushNotification', this.pushHandler.bind(this));
  },
  methods: {
    pushHandler({ detail: { type, title, body } }) {
      this.push(type, title, body);
    },
    push(type, title, body) {
      this.sequence += 1;
      const id = this.sequence + 0;
      const timeoutId = setTimeout(() => this.remove(id), 8000);
      this.messages.push({
        id, type, title, body, show: true, timeoutId,
      });
    },
    remove(messageId) {
      const message = this.messages.find((_message) => messageId === _message.id);
      message.show = false;
      clearTimeout(message.timeoutId);
      setTimeout(() => {
        this.messages = this.messages.filter((_message) => messageId !== _message.id);
      }, 1000);
    },
  },
  beforeUnmount() {
    window.removeEventListener('search:pushNotification', this.addHandler.bind(this));
  },
};
</script>

<template>
  <div class="fixed inset-0 flex items-end px-4 py-6
  pointer-events-none sm:p-6 sm:items-start z-40">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <SimpleNotification
        v-for="message in messages"
        :key="message.id"
        :type="message.type"
        :title="message.title"
        :body="message.body"
        :show="message.show"
        @close="remove(message.id)"
      />
    </div>
  </div>
</template>
